export default function SudokuPrivacyPolicy() {
  return (
    <main className="premium-page">
      <section className="premium-shell">
        <div className="page-hero-block">
          <p className="eyebrow">Sudoku app privacy</p>
          <h1 className="hero-heading mt-5">Sudoku Privacy Policy.</h1>
          <p className="hero-copy">
            This privacy policy applies to the Sudoku app published by Code7s.
            It explains what information the app collects, how it is used, and
            how users can contact us.
          </p>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.18em] text-neutral-500">
            Last updated: August 18, 2026
          </p>
        </div>

        <div className="mx-auto mt-14 grid max-w-5xl gap-5">
          {[
            {
              title: "Information collected by the Sudoku app",
              body: "The Sudoku app is designed as a puzzle game experience. The app does not require users to create an account and does not ask for personal information such as name, email address, phone number, or address.",
            },
            {
              title: "Gameplay data",
              body: "The app may store gameplay progress, settings, preferences, puzzle state, scores, and app usage choices locally on your device so the game can function properly and remember your experience.",
            },
            {
              title: "Analytics and diagnostics",
              body: "If analytics or crash reporting tools are enabled, the app may collect non personal technical information such as device type, operating system, app version, crash logs, performance data, and general usage events. This helps improve stability and user experience.",
            },
            {
              title: "Advertising and third party services",
              body: "If the Sudoku app includes ads or third party services in the future, those providers may process limited device or usage information according to their own privacy policies. Code7s does not sell personal information.",
            },
            {
              title: "Children privacy",
              body: "The Sudoku app is intended as a general puzzle game. We do not knowingly collect personal information from children. If you believe a child has provided personal information, contact us so we can review and delete it where applicable.",
            },
            {
              title: "Data security",
              body: "We use reasonable safeguards to protect app related information. No method of storage or transmission is completely secure, but we aim to limit collection and protect information used to operate the app.",
            },
            {
              title: "Changes to this policy",
              body: "We may update this Sudoku privacy policy when app features, analytics, advertising, platform requirements, or legal obligations change. Updated versions will be posted on this page.",
            },
          ].map((section) => (
            <section key={section.title} className="glass-card rounded-[24px] p-6 text-center">
              <h2 className="text-2xl font-extrabold tracking-tight text-neutral-950">
                {section.title}
              </h2>
              <p className="section-copy mt-4">{section.body}</p>
            </section>
          ))}
        </div>

        <section className="mx-auto mt-10 max-w-5xl text-center">
          <h2 className="section-heading mb-6">Contact</h2>
          <p className="section-copy">
            For questions about the Sudoku app privacy policy, contact Code7s at
            code7s.official@gmail.com.
          </p>
        </section>
      </section>
    </main>
  );
}
